import * as React from 'react';
import { bannerEnter, bannerEnterActive, bannerExitActive, banner, transitionDurationLongMs } from './webgiving-main-banner.less';
import CSSTransition from 'react-transition-group/CSSTransition';
import { isIE } from '../../../Shared/helpers/browser-support-helper';

export class WebGivingMainBanner extends React.Component<{ visible: boolean, className?: string }, {}> {
	render() {
		const {
			visible,
			className = '',
		} = this.props;

		const appearClassName = isIE() ? undefined : bannerEnter;
		const appearActiveClassName = isIE() ? undefined: bannerEnterActive;
		const classNames = {
			appear: appearClassName,
			appearActive: appearActiveClassName,
			enter: bannerEnter,
			enterActive: bannerEnterActive,
			exitActive: bannerExitActive,
		};

		return (
			<CSSTransition in={visible}
				timeout={parseInt(transitionDurationLongMs, 10)}
				classNames={classNames} appear unmountOnExit>
				<div className={`${className} ${banner}`} />
			</CSSTransition>);
	}
}
